goog.provide('el8.appshared.dialog.drugIntxnDetail');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.appshared.drugIntxns');
goog.require('el8.template.appshared.dialog.drugIntxnDetail');


el8.appshared.dialog.drugIntxnDetail = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: "Drug Interaction Details",
        autoHeight: true,
        width: 500,
        modal: false,
        contentFn: el8.template.appshared.dialog.drugIntxnDetail.content,
        showXButton: true
    });

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that.getContentElt().on('click', '.monograph-show-hide',  function(e) {
            var showHideLink = $(e.target);
            var mid = showHideLink.attr('_mid');
            var monographContainer = $('#monograph-' + mid);
            var monographIsVisible = monographContainer.is(":visible");
            if (monographIsVisible) {
                showHideLink.html("Show Monograph");
                monographContainer.hide();
            } else {
                showHideLink.html("Hide Monograph");
                monographContainer.show();
            }
            return false;
        });
    };

    var super_show = that.show;
    that.show = function(data) {
        super_show.call(that);
        if (data['type'] === 'drugDrug') {
            $('.drug-intxn-detail-content', that.getContentElt()).html(
                el8.template.appshared.drugIntxns.drugDrugIntxnDetail(data)
            );
        } else if (data['type'] === 'drugAllergy') {
            $('.drug-intxn-detail-content', that.getContentElt()).html(
                el8.template.appshared.drugIntxns.drugAllergyIntxnDetail(data)
            );
        }

        that.adjustHeight();
    };

    return that;

})();
